import { createSelector } from 'reselect'
import { permissionSelector } from './permission'

export const getList = (state, props) => {
  return state['view-myboard'].lists[props.id]
}

export const getCardsById = (state, props) => {
  return state['view-myboard'].cards
}

export const getListCards = (state, props) => {
  return state['view-myboard'].lists[props.id].cards
}

export const makeCardsSelector = () => createSelector(
  [getListCards, getCardsById],
  (cards, cardsById) =>
    cards
      .map(id => cardsById[id])
      .sort((a, b) => a.position - b.position)
      .map(card => card.id)
)

export const getListCount = (state, props) => {
  return state['view-myboard'].view.lists.length
}

export const makeListSelector = () => {
  const cardsSelector = makeCardsSelector()

  return createSelector(
    [
      getList,
      cardsSelector,
      getListCount,
      permissionSelector
    ],
    (
      list,
      cards,
      listCount,
      permission
    ) => ({
      ...list,
      cards,
      listCount,
      permission
    })
  )
}

export const listSelector = makeListSelector()
